<script setup lang="ts">
import EnrollFormModal from '~/components/newhouse/list/EnrollFormModal.vue'
import { useCustomNeedLoginAction } from '~/composables/customNeedLoginAction'

const props = defineProps({
  adviserList: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
  configId: {
    type: String,
    default: '',
  },
  applyGroupConfigId: {
    type: String,
    default: '',
  },
  isFavorite: {
    type: [Number, Boolean],
    default: 0,
  },
  sortId: {
    type: Number,
    default: 5,
  },
  numberId: {
    type: Number,
    default: 0,
  },
  dataId: {
    type: Number,
    default: null,
  },
})

// interface propsType {
//   adviserList?: any[] // 置业顾问列表
//   configId?: string // 咨询顾问配置id
//   applyGroupConfigId?: string // 加群配置id
//   isFavorite?: boolean | number
//   [key: string]: any
// }

const emit = defineEmits(['likeChange'])

const like = computed(() => {
  return (props?.isFavorite === 1) || (props?.isFavorite === true)
})

const active = ref<number>(999)

/**
 * ！！！！！基础数据，使用此组件的时候需要注入这两项数据
 * floorInfo: 楼盘信息
 * configMap: 配置组
 */
const floorInfo = inject<any>('floorInfo')
const configMap = inject<any>('configMap')

const LazyWxQrImage = defineAsyncComponent(() => import('@/components/WechatDial/WxQrFloorDetailImage.vue'))

const { city } = useCityInfoStore()
const enrollFormModalRef = ref()

/**
 * 指定加群配置id为applyGroupConfigId
 */
function openDiscountModal() {
  active.value = 1
  const config = configMap.value?.[props.applyGroupConfigId] || {}
  if (enrollFormModalRef.value) {
    enrollFormModalRef.value.showModal({
      businessId: config?.configId,
      cityId: floorInfo?.cityId || city,
      floorId: floorInfo.value.floorId,
      source: '新房/pc/楼盘信息',
      sourceTypeId: 1,
    }, config)
  }
}

onMounted(() => {
  /**
   * 如果存在置业顾问
   * 三秒后自动打开咨询弹窗
   */
  if (props.adviserList.length > 0) {
    setTimeout(() => {
      active.value = 0
    }, 3000)
  }
})

/**
 * 返回顶部
 */
function handleTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/**
 * 咨询
 */
function handleConsult(index: number) {
  active.value = index === active.value ? 999 : index
}

const { commonCollect } = userInfoAction()
// 咨询置业顾问
async function handleCollect(adviserId: number) {
  const config = configMap.value?.[props.configId] || {}
  await commonCollect({
    configId: config?.configId,
    cityId: floorInfo.value?.cityId,
    floorId: floorInfo.value.floorId,
    source: '新房/PC/楼盘首页',
    sourceTypeId: 1,
    adviserId,
    message: '我刚浏览了这个楼盘，请问可以介绍下吗？',
  })
}

/**
 * 以下为收藏相关处理方法
 * 组合收藏数据
 */
const params = computed(() => {
  if (props?.dataId) {
    return Object.assign({}, { cityId: floorInfo.value?.cityId || city, numberId: props?.numberId, source: 1, sortId: props?.sortId, dataId: props?.dataId })
  }
  else {
    return Object.assign({}, { cityId: floorInfo.value?.cityId || city, numberId: props?.numberId, source: 1, sortId: props?.sortId })
  }
})

const store = useUserInfoStore()

async function handleClick(event: any) {
  active.value = 2
  event.stopPropagation()
  const userInfo: any = await store.getUserInfo(true)
  if (userInfo?.isLogin) {
    const action = like.value ? cancelLike : toLike
    action()
  }
}
const { handleSaveFavorite, handleDeleteFavorite } = useCustomNeedLoginAction()
function toLike() {
  handleSaveFavorite(params.value).then((res: any) => {
    const { code } = res
    if (code === 0) {
      emit('likeChange', !like.value ? 1 : 0)
    }
  })
}

// 取消收藏、取消关注
function cancelLike() {
  handleDeleteFavorite(params.value).then((res: any) => {
    const { code } = res
    if (code === 0) {
      emit('likeChange', !like.value ? 1 : 0)
    }
  })
}

const shuffledAdviserList = computed(() => {
  return [...props.adviserList].sort(() => Math.random() - 0.5)
})
</script>

<template>
  <div class="tool-box">
    <div v-if="adviserList?.length > 0" class="tool-li" :class="{ active: active === 0 }" @click="handleConsult(0)">
      <MessageOutlined class="icon-style" />
      <span>咨询</span>
    </div>
    <div v-if="configMap?.[applyGroupConfigId]" class="tool-li" @click="openDiscountModal()">
      <i class="icon-style iconfont icon-shouqianzixun" />
      <span>申请入群</span>
    </div>
    <div class="tool-li">
      <HeartOutlined v-if="like" class="icon-style like" @click.prevent="handleClick" />
      <i v-else class="icon-style iconfont icon-chakantieziguanzhu" @click.prevent="handleClick" />
      <span>{{ like ? '已关注' : '关注' }}</span>
    </div>
    <a-popover placement="left">
      <template #content>
        <ClientOnly>
          <LazyWxQrImage v-bind="floorInfo" />
        </ClientOnly>
      </template>
      <div class="tool-li">
        <ShareAltOutlined class="icon-style" />
        <span>分享</span>
      </div>
    </a-popover>
    <div class="tool-li" @click="handleTop">
      <i class="icon-style iconfont icon-fanhuidingbu1" style="font-size: 28px" />
      <span>返回顶部</span>
    </div>
  </div>

  <Transition name="fade">
    <div v-if="active === 0" class="padding-box z-3">
      <div class="consultant">
        <div v-for="item in shuffledAdviserList" :key="item.adviserId" class="data-li">
          <div class="avatar">
            <img :src="item?.headPic" alt="头像">
          </div>
          <div class="info">
            <div class="name">
              {{ item?.trueName }} <img src="@/assets/images/gold-advisor.png" class="gold-advisor" alt="">
            </div>
            <div class="online cursor-pointer" @click="handleCollect(item.adviserId)">
              <img src="@/assets/images/online.png" style="image-rendering: pixelated;" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <!-- 点击申请入群， 弹出框 -->
  <EnrollFormModal ref="enrollFormModalRef" />
</template>

<style scoped lang="scss">
.tool-box {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid #EBEBEB;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  z-index: 99999;

  .tool-li {
    width: 70px;
    height: 70px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #000000;
    font-size: 12px;
    cursor: pointer;
    font-family: Alibaba PuHuiTi 3.0;

    &:hover {
      background: #F5F5F6;
    }

    .icon-style {
      font-size: 22px;
      color: #616669;
      margin-bottom: 6px;
    }

    .like {
      color: #52BE54;
    }
  }

  .active {
    background: #52BE54;
    color: #ffffff;

    &:hover {
      background: #52BE54;
    }

    .icon-style {
      color: #ffffff !important;
    }
  }
}

.padding-box {
  position: fixed;
  right: 95px;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 0;
  height: 352px;
  background: #F5F5F6;
  border: 1px solid #DEDEDE;
  border-radius: 4px;

  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);

  .consultant {
    width: 235px;
    height: 330px;
    overflow: hidden;
    overflow-y: scroll;
    //background: #F5F5F6;
    padding: 0 17px;
    padding-right: unset;
    //z-index: 99998;

    &::-webkit-scrollbar {
      // width: 8px; /* 滚动条宽度 */
      width: 10px; /* 滚动条宽度 */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #C0C0C0; /* 滚动条颜色 */
      border-radius: 10px; /* 滚动条圆角 */
      border: 2px solid transparent; /* 给滚动条留空隙，创建内边距效果 */
      background-clip: content-box; /* 内边距与滚动条颜色分离 */
    }
    &::-webkit-scrollbar-track {
      background-color: transparent; /* 滚动条轨道背景设置为透明 */
    }
    /* 针对 Firefox */
    container {
      scrollbar-width: thin; /* 将滚动条宽度设置为“细” */
      scrollbar-color: #E1E1E1 transparent; /* 设置滚动条颜色和轨道颜色 */
    }

    .data-li {
      display: flex;
      align-items: center;
      // padding: 10px 0;
      padding: 15px 0;

      .avatar {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        overflow: hidden;
        position: relative;

        img {
          //width: 100%;
          //position: absolute;
          //top: 50%;
          //left: 50%;
          //transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .info {
        margin-left: 17px;
        line-height: 30px;

        .name {
          font-size: 16px;
          color: #3D3D3D;
          display: flex;

          .gold-advisor {
            height: 22px;
            margin-left: 5px;
          }
        }
        .online {
          //margin-top: 2px;
          width: 105px;

          img {
            width: 100%;
          }
        }
      }
    }

    .data-li + .data-li {
      border-top: 1px solid #EAEAEA;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  //width: 0;
  right: 0px;
}
</style>
